module.exports = __webpack_public_path__ + "bikes.gif";


//////////////////
// WEBPACK FOOTER
// ./presentations/example/images/bikes.gif
// module id = 137
// module chunks = 0